import * as moment_ from 'moment-timezone';
// workaround because the build otherwise throws "Cannot call a namespace ('moment')"
const moment = moment_;

import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ServiceFilterTranslation,
  DateOptions,
  FilterOptions,
} from '../../../../models/notification-history.model';

const ALL = 'all';

const today = () => moment().startOf('day');
const yesterdayFrom = () => moment().subtract(1, 'days').startOf('day');
const yesterdayTo = () => moment().subtract(1, 'days').endOf('day');
const lastWeekFrom = () => moment().subtract(1, 'weeks').startOf('day');
const lastWeekTo = () => moment().subtract(1, 'weeks').endOf('day');
const lastMonthFrom = () => moment().subtract(1, 'months').startOf('day');
const lastMonthTo = () => moment().subtract(1, 'months').endOf('day');

@Component({
  selector: 's2a-pure-timeline-filter',
  templateUrl: './pure-timeline-filter.component.html',
  styleUrls: ['./pure-timeline-filter.component.scss'],
})
export class PureTimelineFilterComponent {
  /**
   * Filter option to pre-fill the filter menu
   *
   * @optional
   */
  @Input() set filterOptions(options: FilterOptions) {
    this.initFilterOptions(options);
  }

  /**
   * Emits an cancel click event
   *
   * @returns void
   */
  @Output() cancelClicked = new EventEmitter<void>();

  /**
   * Triggered when filter should be applied.
   *
   * @returns FilterOptions
   */
  @Output() applyFilterClicked = new EventEmitter<FilterOptions>();

  /**
   * @ignore
   */
  allServices = [
    { key: ALL, value: 'global.all' },
    ...ServiceFilterTranslation.sort((a, b) => (a.key > b.key ? 1 : -1)),
  ];

  /**
   * @ignore
   */
  today = today().toDate().toISOString();

  /**
   * @ignore
   */
  dateOptions = DateOptions;

  /**
   * @ignore
   */
  selectedServices = [ALL];

  /**
   * @ignore
   */
  selectedDateOption: '' | DateOptions = '';

  /**
   * @ignore
   */
  dateRange = {
    start: '',
    end: '',
  };

  /**
   * @ignore
   */
  selectedStartDateInMs: number;

  /**
   * @ignore
   */
  selectedEndDateInMs: number;

  /**
   * @ignore
   */
  isSelectedService(service: string): boolean {
    return this.selectedServices.includes(service);
  }

  /**
   * @ignore
   */
  onSelectService(service: string): void {
    if (service === ALL) {
      this.selectedServices = [ALL];
    } else {
      this.removeFromArray(ALL);
    }

    if (!this.selectedServices.includes(service)) {
      this.selectedServices.push(service);
    } else {
      this.removeFromArray(service);
    }

    if (!this.selectedServices.length) {
      this.selectedServices.push(ALL);
    }

    if (this.selectedServices.length === this.allServices.length - 1) {
      this.selectedServices = [ALL];
    }
  }

  /**
   * @ignore
   */
  isSelectedDateOption(option: string): boolean {
    return this.selectedDateOption === option;
  }

  /**
   * @ignore
   */
  onSelectDateOption(option: DateOptions): void {
    if (this.isSelectedDateOption(option)) {
      this.selectedDateOption = '';
    } else {
      this.selectedDateOption = option;

      switch (option) {
        case 'yesterday':
          this.selectedStartDateInMs = yesterdayFrom().toDate().getTime();
          this.selectedEndDateInMs = yesterdayTo().toDate().getTime();
          break;
        case 'last_week':
          this.selectedStartDateInMs = lastWeekFrom().toDate().getTime();
          this.selectedEndDateInMs = lastWeekTo().toDate().getTime();
          break;
        case 'last_month':
          this.selectedStartDateInMs = lastMonthFrom().toDate().getTime();
          this.selectedEndDateInMs = lastMonthTo().toDate().getTime();
          break;
        case 'custom':
          break;
      }
    }
  }

  /**
   * @ignore
   */
  onSelectDateRange(dateRange: CustomEvent): void {
    const range = JSON.parse(dateRange.detail);

    this.dateRange.start = range.start;
    this.selectedStartDateInMs = new Date(range.start).getTime();

    this.dateRange.end = range.end;
    this.selectedEndDateInMs = new Date(range.end).getTime();
  }

  /**
   * @ignore
   */
  onResetFilter(): void {
    this.selectedServices = [ALL];
    this.selectedDateOption = '';
    this.dateRange = {
      start: '',
      end: '',
    };
    this.selectedStartDateInMs = undefined;
    this.selectedEndDateInMs = undefined;
  }

  /**
   * @ignore
   */
  onApplyFilter(): void {
    this.applyFilterClicked.emit({
      services: !this.selectedServices.includes(ALL)
        ? this.selectedServices
        : undefined,
      date: !this.isSelectedDateOption('')
        ? {
            identifier: this.selectedDateOption as DateOptions,
            from: this.selectedStartDateInMs,
            to: this.selectedEndDateInMs,
          }
        : undefined,
    });
  }

  /**
   * @ignore
   */
  onCancelClicked(): void {
    this.initFilterOptions(this.filterOptions);
    this.cancelClicked.emit();
  }

  /**
   * @ignore
   */
  private removeFromArray(item: string): void {
    const index = this.selectedServices.indexOf(item);
    if (index > -1) {
      this.selectedServices.splice(index, 1);
    }
  }

  /**
   * @ignore
   */
  private initFilterOptions(options: FilterOptions): void {
    if (options && options.services) {
      this.selectedServices = options.services;
    }

    if (options && options.date) {
      this.selectedDateOption = options.date.identifier;
      this.selectedStartDateInMs = options.date.from;
      this.selectedEndDateInMs = options.date.to;

      if (this.isSelectedDateOption('custom')) {
        this.dateRange.start = new Date(options.date.from).toISOString();
        this.dateRange.end = new Date(options.date.to).toISOString();
      }
    }
  }
}
